import React, { useState } from 'react';

import NotificationList from '@portal/components/NotificationList';
import { translate } from '@portal/services/i18n';
import './NotificationsPage.less';
import AdvancedHeader from '@portal/components/AdvancedHeader/AdvancedHeader';
import { getRouteStackPath } from '@portal/config/routes';
import AdvancedPanelContentHeader from '@portal/components/AdvancedPanelContentHeader/AdvancedPanelContentHeader';
import AdvancedCard from '@portal/components/AdvancedCard/AdvancedCard';
import GenericModal from '@portal/components/GenericModal/GenericModal';
import { DateTime } from 'luxon';
import ThemedText from '@portal/components/ThemedText/ThemedText';
import { useNavigation } from '@portal/hooks/useNavigation';

const NotificationsPage: React.FC = () => {
  const navigate = useNavigation();
  const [selectedNotification, setSelectedNotification] =
    useState<models.Notification | null>(null);

  const handleNotificationClick = (notification: models.Notification) => {
    setSelectedNotification(notification);
  };

  return (
    <>
      <AdvancedHeader
        showBreadCrumbs
        breadCrumbs={[
          {
            active: true,
            title: translate('COMPONENTS.BREADCRUMB.HOME'),
            url: getRouteStackPath('HOME', 'HOME_PAGE'),
          },
          {
            active: false,
            title: translate('PAGES.NOTIFICATIONS.TITLE'),
          },
        ]}
      />
      <div className="notifications-page">
        <AdvancedPanelContentHeader
          testId="notifications-header-panel"
          title={translate('PAGES.NOTIFICATIONS.TITLE')}
          description={translate('PAGES.NOTIFICATIONS.DESCRIPTION')}
          goBackAction={() => navigate(getRouteStackPath('HOME', 'HOME_PAGE'))}
          buttonTitle={translate('APPLICATION.BACK_TO_INIT')}
        />
        <AdvancedCard testId="notifications-content-card">
          <NotificationList
            pageSize={20}
            showPagination={true}
            onNotificationClick={handleNotificationClick}
          />
        </AdvancedCard>
      </div>
      <GenericModal
        visible={!!selectedNotification}
        onClose={() => setSelectedNotification(null)}
        title={selectedNotification?.title}
      >
        <ThemedText variant="body">{selectedNotification?.message}</ThemedText>
        <ThemedText variant="body">
          {DateTime.fromISO(selectedNotification?.createdAt || '').toFormat(
            translate('APPLICATION.DEFAULT_DATE_FORMAT.LUXON')
          )}
        </ThemedText>
      </GenericModal>
    </>
  );
};

export default NotificationsPage;
